export default function StatusTriSelect({ value, onChange }) {
  const OPTIONS = [
    {
      key: "active", label: "Active", desc: "Live pricing · Instant checkout",
      activeBorder: "border-emerald-500", activeBg: "bg-emerald-50 dark:bg-emerald-900/20",
      dotOn: "border-emerald-600 bg-emerald-600",
    },
    {
      key: "upon_request", label: "Upon Request", desc: "Visible on /book · Opens inquiry modal",
      activeBorder: "border-amber-500", activeBg: "bg-amber-50 dark:bg-amber-900/20",
      dotOn: "border-amber-600 bg-amber-600",
    },
    {
      key: "inactive", label: "Inactive", desc: "Hidden from public search entirely",
      activeBorder: "border-rose-500", activeBg: "bg-rose-50 dark:bg-rose-900/20",
      dotOn: "border-rose-600 bg-rose-600",
    },
  ];
  return (
    <div
      role="radiogroup"
      className="grid grid-cols-1 md:grid-cols-3 gap-3"
      data-testid="status-tri-select"
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.key;
        return (
          <button
            type="button"
            role="radio"
            aria-checked={active}
            key={opt.key}
            onClick={() => onChange(opt.key)}
            data-testid={`status-option-${opt.key}`}
            className={`text-left p-3 rounded border transition-colors ${
              active
                ? `${opt.activeBorder} ${opt.activeBg}`
                : "border-black/10 dark:border-white/10 hover:border-black dark:hover:border-white"
            }`}
          >
            <div className="flex items-center gap-2">
              <span className={`w-3 h-3 rounded-full border-2 ${active ? opt.dotOn : "border-neutral-400"}`} />
              <p className="text-sm font-medium">{opt.label}</p>
            </div>
            <p className="text-[11px] text-neutral-500 dark:text-neutral-400 mt-1 leading-snug">{opt.desc}</p>
          </button>
        );
      })}
    </div>
  );
}
